import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { BackendSessionService } from '@app/core/services/session/backend-session.service';
import { Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Directive({
  selector: '[vfsBackendSession]'
})
export class BackendSessionDirective implements OnInit, OnDestroy {
  @Input() sessionConcept: string;
  @Input() sessionId$: Subject<string>;

  sessionHold: string;

  constructor(protected backendSessionService: BackendSessionService) {}

  ngOnInit(): void {
    this.backendSessionService
      .open(this.sessionConcept)
      .pipe(
        catchError(error => {
          console.error('Unable to obtain session for concept ' + this.sessionConcept);
          return throwError(error);
        }),
        tap(sessionId => {
          this.sessionHold = sessionId;
          this.sessionId$.next(this.sessionHold);
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.sessionHold) {
      this.backendSessionService.close(this.sessionHold).subscribe();
    }
  }
}
